<!-- =========================================================================================
    File Name: KnowledgeBase.vue
    Description: Knowledge Base Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="knowledge-base-page">
        <!-- JUMBOTRON -->
        <div class="knowledge-base-jumbotron">
            <div class="knowledge-base-jumbotron-content p-4 rounded-lg mb-base text-center">
              <h4 class="mb-2 text-white">{{title}}</h4>
              <div class="text-white mb-base" v-if="desc">{{desc}}</div>

              <div class="text-white">
                <vs-button @click="initiateLiveChat()">{{$t('action.contactUs')}}</vs-button>
              </div>
            </div>
        </div>
        <div class="mb-2" v-for="error in api_errors" :key="error.message">
            <vs-alert color="danger" icon="new_releases" >
            <span>{{error}}</span>
            </vs-alert>
        </div>
    </div>
</template>

<script>

export default{
  name: 'help-center-contact-us',
  props: {
    title: {
      type: String,
      default: 'Hello, how can we help?'
    },
    desc: {
      type: String,
      default: ''
    },
  },
  methods: {
    initiateLiveChat(){
      window.open(this.$endpoints.public_livechat, '_blank')
    }
  },
}
</script>

<style lang="scss">
.knowledge-base-jumbotron-content {
    background-image: url('/images/pages/help-center.jpg');
    background-size: cover;
}
</style>
